import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProductCardComponent } from './products-v2/product-card/product-card.component';

@NgModule({
  exports: [ProductCardComponent],
  imports: [RouterModule, ProductCardComponent],
})
export class ProductsSharedModule {}
